<template>
    <div class="wrapper-errors-list">
        <div class="card fts-table-wrapper">
            <div class="card-header">
                <div>Error Logs</div>
            </div>
            <div class="card-body">
                <div class="filter-row">
                    <div class="left-side">
                        <div class="search-box">
                            <b-form-group>
                                <b-input-group>
                                    <input type="text" class="form-control"  v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                                </b-input-group>
                            </b-form-group>
                        </div>
                        <button class="btn btn-primary" @click="showFilters()"><i class="fa fa-filter"></i>Filter</button>
                    </div>
                    <div class="size-page-wrapper text-right">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="fts-table table-responsive-sm">
                    <table v-if='errorsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment fts-table error-list-table">
                        <thead role="rowgroup">
                        <tr role="row">
                            <th v-on:click="changeSort(1)" :aria-sort="setAreaSort(1)">ID</th>
                            <th v-on:click="changeSort(0)" :aria-sort="setAreaSort(0)">Time</th>
                            <th v-on:click="changeSort(3)" :aria-sort="setAreaSort(3)">User</th>
                            <th v-on:click="changeSort(8)" :aria-sort="setAreaSort(8)">IP</th>
                            <th v-on:click="changeSort(9)" :aria-sort="setAreaSort(9)">App version</th>
                            <th v-on:click="changeSort(5)" :aria-sort="setAreaSort(5)">Company</th>
                            <th v-on:click="changeSort(4)" :aria-sort="setAreaSort(4)">URL</th>
                            <th v-on:click="changeSort(6)" :aria-sort="setAreaSort(6)">Exception Type</th>
                        </tr>
                        </thead>

                        <tbody>
                            <tr @click="showErrorDetails(error)" v-for="error in errorsList" v-bind:key="error.exceptionId">
                                <td>{{error.exceptionId}}</td>
                                <td>{{error.thrownAt}}</td>
                                <td>{{error.username}}</td>
                                <td>{{error.ipAddress}}</td>
                                <td>{{error.appVersion}}</td>
                                <td>{{error.companyName}}</td>
                                <td>{{error.requestUrl}}</td>
                                <td>{{error.exceptionType}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="fts-bottom-table error-list-table-nav">
                    <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                        <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                    </nav>
                    <button class="btn btn-primary btn-on-right" @click="showExportSelect()">Export Error Logs</button>
                </div>

                <div class="loader-errors-list" v-if="loading && noErrors == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>

                <div class="no-errors" v-if="loading == false && noErrors == true">
                    <h2 class="text">No errors have been occured</h2>
                </div>
            </div>
        </div>
        <b-modal size="lg" ref="errorDetails" id="errorDetails" centered hide-footer hide-header>
            <div class="error-details-header">
                <h3>Error details</h3>
                <i @click="hideErrorDetails()" class="fa fa-close"></i>
            </div>
            <div class="error-details-row">
                <strong>Error ID:</strong> {{errorDetailsData.exceptionId}}
            </div>
            <div class="error-details-row">
                <strong>Error source:</strong> {{errorDetailsData.source}}
            </div>
            <div class="error-details-row">
                <strong>Error time:</strong> {{errorDetailsData.thrownAt}}
            </div>
            <div class="error-details-row">
                <strong>Username:</strong> {{errorDetailsData.username}}
            </div>
            <div class="error-details-row">
                <strong>Error URL:</strong> {{errorDetailsData.requestUrl}}
            </div>
            <div class="error-details-row">
                <strong>Company:</strong> {{errorDetailsData.companyName}}
            </div>
            <div class="error-details-row">
                <strong>Exception type:</strong> {{errorDetailsData.exceptionType}}
            </div>
            <div class="error-details-row message">
                <strong>Error message:</strong> {{errorDetailsData.message}}
            </div>
        </b-modal>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>
        <b-modal size="lg" ref="filters" id="filters" centered hide-footer hide-header>
            <div class="filters-content">
                <div class="left-side">
                    <h3>Enviroment</h3>
                    <div class="enviroment-box">
                        <FTScheckbox v-model="enviroment.production" :label="'Production'"></FTScheckbox>
                        <FTScheckbox v-model="enviroment.development" :label="'Development'"></FTScheckbox>
                        <FTScheckbox v-model="enviroment.staging" :label="'Staging'"></FTScheckbox>
                        <FTScheckbox v-model="enviroment.local" :label="'Local'"></FTScheckbox>
                    </div>
                    <h3>User email</h3>
                    <div class="email-box">
                        <FTScheckbox v-model="userEmail.present" :label="'Present'"></FTScheckbox>
                        <FTScheckbox v-model="userEmail.blank" :label="'Blank'"></FTScheckbox>
                    </div>
                    <h3>Data range</h3>
                    <div class="dates-box">
                        <div class="date">
                            <h4>Start Date</h4>
                            <date-picker valueType="format" v-model="dateRange.startDate" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                        </div>
                        <div class="date">
                            <h4>End Date</h4>
                            <date-picker valueType="format" v-model="dateRange.endDate" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                        </div>
                        <span v-if="dateErrorMsg != ''" class="error-msg">{{dateErrorMsg}}</span>
                    </div>
                </div>
                <div class="right-side">
                    <div class="right-side-header">
                        <h3>Exception types</h3>
                        <div class="unselect-and-close-box">
                            <a @click="clearFilters()">UNSELECT ALL</a>
                            <i class="fa fa-close" @click="cancelFilters()"></i>
                        </div>
                    </div>
                    <div class="fts-dropdown error-logs-dropdown" v-click-outside="closeDropdown">
                        <div :class="['dropdown-control', openedDropdown ? 'straight-border' : '']" @click="openCloseDropdown">
                            <span class="dropdown-title" v-if="selectedErrorTypes.length == 0">Exception types</span>
                            <div v-else class="selected-list">
                                <div v-for="selected in displaySelectedErrorTypes" class="selected-item">
                                    {{selected.label}}
                                    <i class="fa fa-times-circle" @click.stop="deselectOption(selected)"></i>
                                </div>
                            </div>
                            <span class="count-hidden">
                                        {{countHiddenErrorTypes}}
                                    </span>
                            <i :class="['fa', openedDropdown ? 'fa-caret-up' : 'fa-caret-down']"></i>
                        </div>
                        <div :class="['dropdown-list', openedDropdown ? 'list-visible' : '']">
                            <div class="dropdown-search">
                                <i class="fa fa-search"></i>
                                <input v-model="searchedPhrase" type="text" placeholder="Search" @keyup="searchPhrase"/>
                            </div>
                            <div class="dropdown-options">
                                <div class="dropdown-option">
                                    <label class="dropdown-label" :for="'error-option0'" :option-selected="isAllRowSelected()">
                                        <input class="dropdown-checkbox" :id="'error-option0'" type="checkbox" :checked="isAllRowSelected()" @change="selectAllOption()">
                                        <span></span>
                                        <span class="option-content">Select All Types</span>
                                    </label>
                                </div>
                                <div class="dropdown-option" v-for="row in displayedErrorTypes">
                                    <label class="dropdown-label" :for="'error-option' + row.value" :option-selected="row.selected">
                                        <input class="dropdown-checkbox" :id="'error-option' + row.value" type="checkbox" :checked="row.selected" @change="selectOption(row)">
                                        <span></span>
                                        <span class="option-content">{{row.label}}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="clear-box">
                                <button class="btn btn-light clear-btn" @click="clearDropdown">Clear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="control-bar">
                <div class="left-side">
                    <button class="btn btn-light" @click="clearFilters()">Set default</button>
                </div>
                <div class="right-side">
                    <button class="btn btn-light" @click="cancelFilters()">Cancel</button>
                    <button class="btn btn-primary" @click="setFilters()">Apply</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import globalStore from '../../variables'
    import Axios from 'axios'
    import Paginate from 'vuejs-paginate'
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import DatePicker from 'vue2-datepicker'
    import XLSX from 'xlsx';

    export default {
        name: "ErrorLogs",
        components: {
            Paginate,
            FTScheckbox,
            DatePicker
        },
        data() {
            return {
                loading: true,
                noErrors: false,
                paginationCount: 0,
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 0,
                    desc: true
                },
                filter: '',
                searchString: '',
                timerSearch: '',
                errorsList: [],
                errorTypes: [],
                errorDetailsData: {},
                openedDropdown: false,
                searchedPhrase: '',
                displayedErrorTypes: [],
                selectedErrorTypes: [],
                displaySelectedErrorTypes: [],
                countHiddenErrorTypes: '',
                selectedCount: '',
                enviroment: {
                    development: false,
                    production: false,
                    staging: false,
                    local: false
                },
                userEmail: {
                    present: false,
                    blank: false
                },
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                filters: '',
                dateErrorMsg: '',
                initialFilters: {
                    enviroment: {
                        development: false,
                        production: false,
                        staging: false,
                        local: false
                    },
                    userEmail: {
                        present: false,
                        blank: false
                    },
                    dateRange: {
                        startDate: null,
                        endDate: null
                    },
                    typesSelected: []
                }
            }
        },
        methods: {
            getErrorsList(notPagination){
                this.loading = true;

                if (notPagination) {
                    this.sortSettings.page = 1;
                    this.getPagination();
                }


                Axios.get(`${globalStore.data.restApiUrl}/exception?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}${this.filters}`)
                .then(response => {
                    this.errorsList = response.data
                    if (this.errorsList.length) {
                        this.noErrors = false;
                    } else {
                        this.noErrors = true;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error)
                    this.loading = false;
                    this.noErrors = true;
                })
            },
            getErrorTypes() {
                Axios.get(globalStore.data.restApiUrl + '/exception/get-exception-types')
                    .then(response => {
                        this.errorTypes = []
                        for (let type of response.data) {
                            this.errorTypes.push({
                                value: type,
                                selected: false,
                                label: type
                            })
                            this.displayedErrorTypes.push({
                                value: type,
                                selected: false,
                                label: type
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getPagination() {
                Axios.get( `${globalStore.data.restApiUrl}/exception/page-count?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}${this.filters}`)
                .then(response => {
                    this.paginationCount = Number(response.data)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                this.getErrorsList(false);
            },
            changesSort(ev) {
                this.sortSettings.sort = ev.target.getAttribute("aria-colindex");

                if (ev.target.getAttribute("aria-sort") == 'none') {
                    document.querySelectorAll("table.table-managment thead th[aria-sort]").forEach(item => {
                        item.setAttribute("aria-sort", 'none')
                    })
                    ev.target.setAttribute("aria-sort", 'ascending')
                    this.sortSettings.desc = false
                } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                    ev.target.setAttribute("aria-sort", 'descending')
                    this.sortSettings.desc = true
                } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                    ev.target.setAttribute("aria-sort", 'ascending')
                    this.sortSettings.desc = false
                }
                this.getErrorsList(true)
            },
            sizePage() {
                this.loading = true;
                this.getErrorsList(true);
            },
            searchKeyUp() {
                clearTimeout(this.timerSearch)
                this.timerSearch = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.timerSearch)
            },
            searchRow: function () {
                this.loading = true;
                this.searchString = '&search=' + escape(this.filter);
                this.getErrorsList(true)
            },
            showErrorDetails(error){
                this.errorDetailsData = error;
                this.$refs['errorDetails'].show();
            },
            hideErrorDetails(){
                this.$refs['errorDetails'].hide();
            },
            hideExportSelect() {
                this.$refs['fileFormatModal'].hide()
            },
            showExportSelect() {
                this.$refs['fileFormatModal'].show()
            },
            hideFilters() {
                this.$refs['filters'].hide()
            },
            showFilters() {
                //this.setInitialFilters();
                this.$refs['filters'].show()
            },
            exportCsv() {
                this.$refs['fileFormatModal'].hide()

                Axios.get(globalStore.data.restApiUrl + "/exception/csv")
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'Error logs list.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['fileFormatModal'].hide()

                Axios.get(globalStore.data.restApiUrl + "/exception/xlsx", {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'Error logs export.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            openCloseDropdown() {
                if (!this.openedDropdown)
                    this.openedDropdown = true;
                else
                    this.openedDropdown = false;
            },
            closeDropdown() {
                if (this.openedDropdown)
                    this.openedDropdown = false;
            },
            searchPhrase() {
                if (this.searchedPhrase != '') {
                    let tempDisplayed = []
                    for (let error of this.errorTypes) {
                        if (error.label.toLowerCase().indexOf(this.searchedPhrase.toLowerCase()) != -1) {
                            let template = error
                            for (let selected of this.selectedErrorTypes) {
                                if (error.value == selected.value && selected.selected) {
                                    template.selected = true
                                    break;
                                }
                            }
                            tempDisplayed.push(template)
                        }
                    }
                    this.displayedErrorTypes = tempDisplayed
                } else {
                    this.displayedErrorTypes = this.errorTypes;
                }
            },
            isAllRowSelected() { //here
                if (this.searchedPhrase == '') {
                    if (this.selectedErrorTypes.length == this.displayedErrorTypes.length) {
                        return true
                    } else {
                        return false;
                    }
                } else {
                    let count = 0
                    for (let error of this.displayedErrorTypes) {
                        for (let selected of this.selectedErrorTypes) {
                            if (error.selected && (error.value == selected.value)) {
                                count++;
                            }
                        }
                    }
                    if (count == this.displayedErrorTypes.length) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            selectAllOption() {
                if (this.isAllRowSelected() == false) {
                    for (let i = 0; i < this.displayedErrorTypes.length; i++) {
                        if (this.displayedErrorTypes[i].selected == false) {
                            this.displayedErrorTypes[i].selected = true
                            this.selectedErrorTypes.push(this.displayedErrorTypes[i])
                        }
                    }
                } else {
                    for (let i = 0; i < this.displayedErrorTypes.length; i++) {
                        if (this.displayedErrorTypes[i].selected == true) {
                            this.displayedErrorTypes[i].selected = false
                            this.selectedErrorTypes = []
                        }
                    }
                }
                if (this.selectedErrorTypes.length > 0) {
                    if (this.selectedErrorTypes.length == 1) {
                        this.selectedCount = '1 error type selected'
                        this.countHiddenErrorTypes = ''
                    } else {
                        this.countHiddenErrorTypes = '(' + (this.selectedErrorTypes.length - 1) + ')'
                        this.selectedCount = this.selectedErrorTypes.length + ' error types selected'
                    }
                } else {
                    this.countHiddenErrorTypes = ''
                    this.selectedCount = 'None selected'
                }
            },
            selectOption(option) {
                option.selected = !option.selected;
                if (option.selected)
                    this.selectedErrorTypes.push(option);
                else
                    this.selectedErrorTypes = this.selectedErrorTypes.filter(item => {
                        return option.value != item.value
                    })

                if (this.selectedErrorTypes.length > 0) {
                    if (this.selectedErrorTypes.length == 1) {
                        this.selectedCount = '1 error type selected'
                        this.countHiddenErrorTypes = ''
                    } else {
                        this.countHiddenErrorTypes = '(' + (this.selectedErrorTypes.length - 1) + ')'
                        this.selectedCount = this.selectedErrorTypes.length + ' error types selected'
                    }
                } else {
                    this.countHiddenErrorTypes = ''
                    this.selectedCount = 'None selected'
                }

                this.displaySelectedErrorTypes = this.selectedErrorTypes.slice(0,1);
            },
            deselectOption(option) {
                this.selectedErrorTypes = this.selectedErrorTypes.filter(item => {
                    return option.value != item.value
                })
                for (let item of this.errorTypes) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }
                for (let item of this.displayedErrorTypes) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }

                if (this.selectedErrorTypes.length > 0) {
                    if (this.selectedErrorTypes.length == 1) {
                        this.selectedCount = '1 error type selected'
                        this.countHiddenErrorTypes = ''
                    } else {
                        this.countHiddenErrorTypes = '(' + (this.selectedErrorTypes.length - 1) + ')'
                        this.selectedCount = this.selectedErrorTypes.length + ' error types selected'
                    }
                } else {
                    this.countHiddenErrorTypes = ''
                    this.selectedCount = 'None selected'
                }

                this.displaySelectedErrorTypes = this.selectedErrorTypes.slice(0,1);
            },
            clearDropdown() {
                this.errorTypes.map(item => {
                    item.selected = false;
                })

                this.displayedErrorTypes.map(item => {
                    item.selected = false;
                })

                this.selectedErrorTypes = [];
                this.openedDropdown = false;
                this.selectedCount = 'None selected'
                this.countHiddenErrorTypes = ''
            },
            setFilters() {
                this.filters = ''
                this.dateErrorMsg = ''

                if (this.dateRange.startDate && this.dateRange.endDate) {
                    if (this.dateRange.startDate > this.dateRange.endDate) {
                        this.dateErrorMsg = 'End date must be later than start date.'
                        return false
                    } else {
                        this.filters += '&startDate=' + this.dateRange.startDate
                        this.filters += '&endDate=' + this.dateRange.endDate
                    }
                } else {
                    if (this.dateRange.startDate) {
                        this.filters += '&startDate=' + this.dateRange.startDate
                    }

                    if (this.dateRange.endDate) {
                        this.filters += '&endDate=' + this.dateRange.endDate
                    }
                }

                if (this.enviroment.production) {
                    this.filters += '&environmentTypes=PROD'
                }
                if (this.enviroment.development) {
                    this.filters += '&environmentTypes=DEMO'
                }
                if (this.enviroment.staging) {
                    this.filters += '&environmentTypes=STAGE'
                }
                if (this.enviroment.local) {
                    this.filters += '&environmentTypes=LOCAL'
                }

                if (this.userEmail.blank) {
                    this.filters += '&userPresence=NO_USER'
                }
                if (this.userEmail.present) {
                    this.filters += '&userPresence=HAS_USER'
                }

                if (this.selectedErrorTypes.length > 0) {
                    let types = []
                    for (let type of this.selectedErrorTypes) {
                        types.push(type.value)
                    }
                    this.filters += '&exceptionTypes=' + types.toString()
                }

                this.hideFilters();
                this.setInitialFilters()
                this.getErrorsList(true)
            },
            clearFilters() {
                this.enviroment = {
                    production: false,
                    development: false,
                    staging: false,
                    local: false
                }

                this.userEmail.present = false
                this.userEmail.blank = false

                this.clearDropdown()

                this.dateRange.startDate = null
                this.dateRange.endDate = null
            },
            setInitialFilters() {
                if (this.enviroment.production) {
                    this.initialFilters.enviroment.production = true
                } else {
                    this.initialFilters.enviroment.production = false
                }

                if (this.enviroment.development) {
                    this.initialFilters.enviroment.development = true
                } else {
                    this.initialFilters.enviroment.development = false
                }

                if (this.enviroment.staging) {
                    this.initialFilters.enviroment.staging = true
                } else {
                    this.initialFilters.enviroment.staging = false
                }

                if (this.enviroment.local) {
                    this.initialFilters.enviroment.local = true
                } else {
                    this.initialFilters.enviroment.local = false
                }

                if (this.userEmail.present) {
                    this.initialFilters.userEmail.present = true
                } else {
                    this.initialFilters.userEmail.present = false
                }

                if (this.userEmail.blank) {
                    this.initialFilters.userEmail.blank = true
                } else {
                    this.initialFilters.userEmail.blank = false
                }

                if (this.dateRange.startDate) {
                    this.initialFilters.dateRange.startDate = this.dateRange.startDate
                } else {
                    this.initialFilters.dateRange.startDate = null
                }

                if (this.dateRange.endDate) {
                    this.initialFilters.dateRange.endDate = this.dateRange.endDate
                } else {
                    this.initialFilters.dateRange.endDate = null
                }

                if (this.selectedErrorTypes.length > 0) {
                    let types = []
                    for (let type of this.selectedErrorTypes) {
                        types.push(type.value)
                    }
                    this.initialFilters.typesSelected = types
                } else {
                    this.initialFilters.typesSelected = []
                }
            },
            cancelFilters() {
                this.enviroment.production = this.initialFilters.enviroment.production
                this.enviroment.development = this.initialFilters.enviroment.development
                this.enviroment.staging = this.initialFilters.enviroment.staging
                this.enviroment.local = this.initialFilters.enviroment.local

                this.userEmail.blank = this.initialFilters.userEmail.blank
                this.userEmail.present = this.initialFilters.userEmail.present

                this.dateRange.startDate = this.initialFilters.dateRange.startDate
                this.dateRange.endDate = this.initialFilters.dateRange.endDate

                if (this.initialFilters.typesSelected.length > 0) {
                    this.selectedErrorTypes = []
                    for (let item of this.initialFilters.typesSelected) {
                        this.selectedErrorTypes.push({
                            value: item,
                            label: item,
                            selected: true
                        })
                    }
                    for (let displayed of this.displayedErrorTypes) {
                        if (this.initialFilters.typesSelected.indexOf(displayed.value) > -1) {
                            displayed.selected = true
                        } else {
                            displayed.selected = false
                        }
                    }
                } else {
                    this.clearDropdown()
                }
                this.hideFilters();
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getErrorsList(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            }
        },
        created() {
            this.getErrorsList(true)
            this.getErrorTypes()
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">

    .wrapper-errors-list {
        .fts-table-wrapper {
            .card-body {
                .filter-row {
                    .left-side {
                        display: flex;
                        .btn-primary {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
    .error-list-table {
        width: 100%;
        max-width: 100%;
        thead {
            th {
                &:nth-child(1) {
                    min-width: 85px;
                }
                &:nth-child(2) {
                    min-width: 130px;
                }
                &:nth-child(3) {
                    min-width: 130px;
                }
                &:nth-child(4) {
                    min-width: 130px;
                }
                &:nth-child(5) {
                    min-width: 150px;
                }
                &:nth-child(6) {
                    min-width: 130px;
                }
                &:nth-child(7) {
                    width: 40%;
                    max-width: 200px;
                }
            }
        }
        tbody {
            tr {
                td {
                    &:nth-child(7) {
                        width: 40%;
                        max-width: 200px;
                    }
                }
            }
        }
        @media (max-width: 1300px) {
            tbody {
                tr {
                    td {
                        &:nth-child(5) {
                            max-width: 340px;
                        }
                    }
                }
            }
        }
    }

    .fts-table-wrapper {
        .error-list-table-nav {
            justify-content: center;
            .btn-on-right {
                position: absolute;
                top: 20px;
                right: 20px;
            }
        }
    }

    .loader-errors-list,
    .no-errors {
        position: absolute;
        top: 120px;
        right: 0;
        bottom: 0;
        left: 0;

        background-color: rgba(255, 255, 255, 0.7);

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;

        .sk-wave {
            height: 60px;
            .sk-rect {
                width: 3px;
                background-color: #39c354;
                border-radius: 4px;
            }
        }

        .text {
            margin-top: 20px;
            text-align: center;
            font-size: 15px;
            font-weight: 700;
        }
    }

    #errorDetails {
        .modal-content {
            .modal-body {
                .error-details-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 16px;
                    h3 {
                        font-size: 16px;
                        font-weight: 700;
                    }
                    i {
                        cursor: pointer;
                    }
                }
                .error-details-row {
                    margin-bottom: 8px;
                    &.message {
                        word-break: break-word;
                    }
                }
            }
        }
    }

    #fileFormatModal___BV_modal_header_ {
        padding-bottom: 0;
    }

    #fileFormatModal___BV_modal_body_ {
        padding-top: 0;
        .file-format-popup {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 0 20px 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }


    #filters___BV_modal_body_ {
        display: flex;
        flex-direction: column;
        padding: 0;
        .filters-content {
            display: flex;
            .left-side {
                width: 400px;
                margin: 0 20px 0 0;
                padding: 20px;
                border-right: 1px solid #d5d5d5;
                h3 {
                    margin: 0 0 20px;
                    font-size: 15px;
                }
                .enviroment-box {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .FTScheckbox {
                        width: 45%;
                        &:last-child {
                            margin: 0 0 30px;
                        }
                    }
                }
                .email-box {
                    display: flex;
                    justify-content: space-between;
                    .FTScheckbox {
                        width: 45%;
                        &:last-child {
                            margin: 0 0 30px;
                        }
                    }
                }
                .dates-box {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    h4 {
                        font-size: 12px;
                        color: #515B65;
                        font-weight: 400;
                    }
                    .date {
                        .mx-datepicker {
                            width: 150px;
                        }
                    }
                    .error-msg {
                        position: absolute;
                        top: 100%;
                        color: #9f191f;
                        font-size: 12px;
                    }
                }
            }
            .right-side {
                flex-grow: 1;
                padding: 20px 20px 20px 0;
                .right-side-header {
                    display: flex;
                    justify-content: space-between;
                    margin: 0 0 20px;
                    h3 {
                        margin: 0;
                        font-size: 15px;
                    }
                    .unselect-and-close-box {
                        display: flex;
                        align-items: center;
                        a {
                            margin: 0 25px 0 0;
                            text-transform: uppercase;
                            color: #0088FF;
                            font-size: 15px;
                            font-weight: 700;
                            cursor: pointer;
                        }
                    }
                }
                .error-logs-dropdown {
                    width: 100%;
                }
            }
        }
        .control-bar {
            .right-side {
                .btn-primary {
                    margin-left: 10px;
                }
            }
        }
    }

    .dark-theme {
        #errorDetails {
            .modal-content {
                .modal-body {
                    background-color: #3a4149;
                    color: #fff;
                }
            }
        }

        #fileFormatModal___BV_modal_content_ {
            background-color: #3a4149;
            color: #EDEEEF;

            button {
                color: #fff;
            }
            .file-format-popup {
                background-color: #3a4149;
                color: #EDEEEF;
            }

            .modal-body {
                button.btn-light {
                    color: #23282c;
                }
            }
        }

        #filters___BV_modal_body_ {
            .filters-content {
                .left-side {
                    border-color: #1a1c1d;
                    .dates-box {
                        h4 {
                            color: #fff;
                        }
                    }
                }
            }
            .control-bar {
                border-color: #1a1c1d;
            }
        }
    }
</style>
